import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  Table,
  Input,
  Button,
} from "reactstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import NF from "../../../assets/images/file.png";

// import ConfirmModal from "../../../Components/Common/ConfirmModal";
import CustomPagination from "../../../Components/Common/CustomePagination";
import {
  addVehicle,
  deleteVehicle,
  editVehicle,
  fetchVehiclesList,
} from "../../../slices/VehicleMaster/thunk";
import AddVehicleModal from "../../../Modals/Vehicle/AddVehicleModal";
import ConfirmModal from "../../../Components/Common/ConfirmModal";
import EditVehicleModal from "../../../Modals/Vehicle/EditVehicleModal";
import VehicleDetailsModal from "../../../Modals/Vehicle/VehicleDetailsModal";
// import AddVehicleModal from "../../../Modals/TaxMaster/Vehicle/AddVehicleModal";
// import EditVehicleModal from "../../../Modals/TaxMaster/Vehicle/EditVehicleModal";
// import ViewVehicleModal from "../../../Modals/TaxMaster/Vehicle/ViewVehicleModal";

// import {
//   addVehicle,
//   deleteVehicle,
//   editVehicle,
//   fetchVehicleList,
// } from "../../../slices/thunks";

const VehicleMaster = () => {
  const dispatch = useDispatch();

  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [debounceSearch, setDebouncedSearch] = useState("");

  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [vehicleIdToDelete, setVehicleIdToDelete] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // Selector
  const selectVehicleListState = (state) => state;

  const vehicleSelector = createSelector(selectVehicleListState, (state) => ({
    vehicles: state.Vehicle.vehicles,
    loading: state.Vehicle.loading,
    error: state.Vehicle.error,
    pagination: state.Vehicle.pagination,
  }));

  const { vehicles, loading, error, pagination } = useSelector(vehicleSelector);

  // Modal toggles
  const toggleAddModal = () => setIsAddModalOpen(!isAddModalOpen);
  const toggleEditModal = () => setIsEditModalOpen(!isEditModalOpen);
  const toggleViewModal = () => setIsViewModalOpen(!isViewModalOpen);
  const toggleConfirmModal = () => setIsConfirmModalOpen(!isConfirmModalOpen);

  // Debounced search
  useEffect(() => {
    const delay = setTimeout(() => setDebouncedSearch(searchTerm), 500);
    return () => clearTimeout(delay);
  }, [searchTerm]);

  // Fetch data
  useEffect(() => {
    dispatch(
      fetchVehiclesList({
        pageNo,
        pageSize,
        sortBy: "createdAt",
        sortOrder: "DESC",
        isPagination: 1,
        searchTerm: debounceSearch.trim(),
      }),
    );
  }, [dispatch, pageNo, pageSize, debounceSearch]);

  // Handlers
  const handleRowClick = (vehicle) => {
    setSelectedVehicle(vehicle);
    toggleViewModal();
  };

  const handleEditClick = (vehicle) => {
    setSelectedVehicle(vehicle);
    toggleEditModal();
  };

  const handleDeleteClick = (id) => {
    setVehicleIdToDelete(id);
    toggleConfirmModal();
  };

  const confirmDelete = async () => {
    if (vehicleIdToDelete) {
      await dispatch(deleteVehicle(vehicleIdToDelete));
      setVehicleIdToDelete(null);
      await dispatch(
        fetchVehiclesList({
          pageNo: 0,
          pageSize,
          sortBy: "createdAt",
          sortOrder: "DESC",
          isPagination: 1,
          searchTerm: debounceSearch.trim(),
        }),
      );
    }
  };

  const handleAddVehicle = async (data) => {
    await dispatch(addVehicle(data));
    toggleAddModal();
    await dispatch(
      fetchVehiclesList({
        pageNo,
        pageSize,
        sortBy: "createdAt",
        sortOrder: "DESC",
        isPagination: 1,
      }),
    );
  };

  const handleUpdateVehicle = async (updatedVehicle) => {
    await dispatch(editVehicle(updatedVehicle));
    toggleEditModal();
    await dispatch(
      fetchVehiclesList({
        pageNo,
        pageSize,
        sortBy: "createdAt",
        sortOrder: "DESC",
        isPagination: 1,
      }),
    );
  };

  document.title = "Vehicle List";

  return (
    <div className="page-content">
      <Container fluid>
        <Card>
          <CardHeader className="d-flex align-items-center flex-wrap gap-2">
            <h4 className="card-title mb-0 me-2">Vehicle List</h4>

            <div className="search-box ms-3">
              <Input
                type="text"
                className="form-control search"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setPageNo(0);
                }}
              />
              <i className="ri-search-line search-icon"></i>
            </div>

            <div className="ms-auto">
              <Button
                color="primary"
                size="sm"
                onClick={() => setShowModal(true)}
                className="btn btn-primary btn-sm"
              >
                <i className="ri-add-line align-bottom me-1"></i>
                Add Vehicle
              </Button>
            </div>
          </CardHeader>

          <CardBody>
            <div className="table-responsive">
              <Table className="table align-middle table-nowrap text-start">
                <thead className="table-light">
                  <tr>
                    <th>Sr No</th>
                    <th>Vehicle No</th>
                    <th>Vehicle Name</th>

                    <th>Model No</th>
                    <th>KM Rate</th>
                    <th>Local Rate</th>
                    <th>Capacity</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    [...Array(pageSize)].map((_, index) => (
                      <tr key={index}>
                        {[...Array(9)].map((__, i) => (
                          <td key={i}>
                            <Skeleton height={25} />
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : error ? (
                    <tr>
                      <td colSpan="9" className="text-danger text-center">
                        {error}
                      </td>
                    </tr>
                  ) : vehicles?.length === 0 ? (
                    <tr>
                      <td colSpan="9" className="text-danger text-center">
                        <img
                          src={NF}
                          alt="No File"
                          style={{ width: "500px", marginTop: "10px" }}
                        />
                      </td>
                    </tr>
                  ) : (
                    vehicles.map((item, index) => (
                      <tr
                        key={item.id}
                        onClick={() => handleRowClick(item)}
                        style={{ cursor: "pointer" }}
                      >
                        <td>{pageNo * pageSize + index + 1}</td>

                        <td>{item?.vehicleNo || "-"}</td>
                        <td>{item?.vehicleName || "-"}</td>
                        <td>{item?.vehicleModelNo || "-"}</td>
                        <td>{item?.kmRate || "-"}</td>
                        <td>{item?.localRate || "-"}</td>
                        <td>{item?.vehicleCapacity || "-"}</td>
                        <td>
                          <div className="d-flex gap-2">
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-success btn-icon"
                              onClick={(e) => {
                                handleEditClick(item);
                                e.stopPropagation();
                              }}
                            >
                              <i className="ri-edit-2-line"></i>
                            </button>

                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger btn-icon"
                              onClick={(e) => {
                                handleDeleteClick(item?.id);
                                e.stopPropagation();
                              }}
                            >
                              <i className="ri-delete-bin-line"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>

            <CustomPagination
              currentPage={pagination?.currentPage}
              totalPages={pagination?.totalPages}
              onPageChange={(page) => setPageNo(page)}
              pageSize={pageSize}
              setPageSize={setPageSize}
              setPageNo={setPageNo}
            />
          </CardBody>
        </Card>

        <AddVehicleModal
          show={showModal}
          toggle={() => setShowModal(false)}
          onSubmit={handleAddVehicle}
        />

        {isEditModalOpen && (
          <EditVehicleModal
            show={isEditModalOpen}
            toggle={toggleEditModal}
            vehicle={selectedVehicle}
            onSubmit={handleUpdateVehicle}
          />
        )}

        <VehicleDetailsModal
          show={isViewModalOpen}
          toggle={toggleViewModal}
          vehicle={selectedVehicle}
        />

        <ConfirmModal
          isOpen={isConfirmModalOpen}
          toggle={toggleConfirmModal}
          title="Delete Vehicle"
          message="Are you sure you want to delete this vehicle?"
          onConfirm={confirmDelete}
        />
      </Container>
    </div>
  );
};

export default VehicleMaster;
